// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"49be3606","323":"0ba64acb","462":"06d387e8","604":"2f99c019","745":"62d6aa7f","851":"7a78954e"}[chunkId] + ".chunk.js";
};